import { configureStore } from '@reduxjs/toolkit';
import agencyReducer from './slices/agencySlice';
import clientReducer from './slices/clientSlice';
import fieldReducer from './slices/fieldSlice';
import picklistReducer from './slices/picklistSlice';
import userReducer from './slices/userSlice';
import segmentReducer from './slices/segmentSlice';
import districtAndStateReducer from './slices/districtAndStateSlice';
import dialerStateReducer from './slices/dialerStateSlice';
import dialerCaseDataReducer from './slices/dialerCaseDataSlice';
import permissionSetReducer from './slices/permissionSetSlice';
import componentDisableReducer from './slices/componentDisableSlice';
import gridSelectedCaseReducer from './slices/gridSelectedCaseSlice';
import predictiveCasesReducer from './slices/predictiveCaseSlice';
import permissionsReducer from './slices/permissionsSlice';
import entityPermissionsReducer from './slices/entityPermissionsSlice';
import entityDIDMappingReducer from './slices/entityDidMappingSlice';
import didProvidersReducer from './slices/didProvidersSlice';
import focusedCaseAllocationReducer from './slices/focusedCaseAllocationSlice';

const store = configureStore({
    reducer: {
        agencies: agencyReducer,
        clients: clientReducer,
        fields: fieldReducer,
        picklists: picklistReducer,
        userList: userReducer,
        segments: segmentReducer,
        districtsAndStates: districtAndStateReducer,
        permissionSet: permissionSetReducer,
        dialerState: dialerStateReducer,
        dialerCaseData: dialerCaseDataReducer,
        componentDisable: componentDisableReducer,
        gridSelectedCase: gridSelectedCaseReducer,
        predictiveCases: predictiveCasesReducer,
        permissions: permissionsReducer,
        entityPermissions: entityPermissionsReducer,
        entityDIDMapping: entityDIDMappingReducer,
        didProviders: didProvidersReducer,
        focusedCaseAllocation: focusedCaseAllocationReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
})

export default store;

// Export dispatch function directly for services
export const dispatch = store.dispatch;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
